import React from "react"

interface DeviceListEmptyProps {
	showFavoritesOnly: boolean
	hasUserDevices: boolean
	isLiveMode: boolean
}

const DeviceListEmpty: React.FC<DeviceListEmptyProps> = ({
	showFavoritesOnly,
	hasUserDevices,
	isLiveMode,
}) => {
	const getMessage = () => {
		if (showFavoritesOnly) return "No favorite devices found"
		if (hasUserDevices) {
			return isLiveMode
				? "Devices are being loaded in live mode..."
				: "Your devices are being loaded..."
		}
		return "Add device IDs above or your devices will load automatically when available"
	}

	return (
		<div className="text-center py-12 text-gray-500 dark:text-gray-400">
			<div className="text-lg mb-2">No devices loaded</div>
			<div className="text-sm">{getMessage()}</div>
		</div>
	)
}

export default DeviceListEmpty
